// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2BxJt","Div":"CustomFadeBox_Div__2UR6U","LargeDiv":"CustomFadeBox_LargeDiv__2m1zq"};